import { HttpClientModule } from "@angular/common/http";
import { APP_INITIALIZER, NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { BrowserModule, provideClientHydration } from "@angular/platform-browser";
import { CloudinaryModule } from "@cloudinary/ng";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { GtagComponent } from "./containers/gtag/gtag.component";
import { RestModule } from "./rest/rest.module";
import { SubdomainService } from "./rest/subdomain.service";
@NgModule({
    declarations: [AppComponent],
    imports: [
        RestModule,
        AppRoutingModule,
        ReactiveFormsModule,
        HttpClientModule,
        BrowserModule,
        CloudinaryModule,
        GtagComponent,
    ],
    providers: [
        provideClientHydration(),
        {
            provide: APP_INITIALIZER,
            useFactory: (subdomainService: SubdomainService) => {
                return () => subdomainService.getClient();
            },
            deps: [SubdomainService],
            multi: true,
        },
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
